exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.height-max[data-v-df020998] {\n    height: 100%;\n    overflow: hidden;\n}\n\n\n", ""]);

// exports
